"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = void 0;
require("./setPublicPath");
const Loadable = require("react-loadable");
const compile_1 = require("./compile");
function client() {
    let config = window.__CONFIG__;
    delete window.__CONFIG__;
    return Loadable.preloadReady().then(() => {
        return { config, compile: compile_1.compile };
    });
}
exports.client = client;
//# sourceMappingURL=index.js.map